/* eslint-disable react/prop-types */

import React, { createContext, useContext, useMemo, useState, useCallback } from "react";

const Ctx = createContext(null);

export function LoadingProvider({ children }) {
  const [active, setActive] = useState(false);

  const show = useCallback(() => {
    setActive(true);
  }, []);
  const hide = useCallback(() => setActive(false), []);

  const value = useMemo(() => ({ active, show, hide }), [active, show, hide]);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useLoading() {
  const ctx = useContext(Ctx);
  if (!ctx) throw new Error("useLoading deve ser usado dentro de <LoadingProvider />");
  return ctx;
}